import { render, staticRenderFns } from "./SwiperControls.vue?vue&type=template&id=0311a934&scoped=true&"
import script from "./SwiperControls.vue?vue&type=script&lang=js&"
export * from "./SwiperControls.vue?vue&type=script&lang=js&"
import style0 from "./SwiperControls.vue?vue&type=style&index=0&id=0311a934&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0311a934",
  null
  
)

export default component.exports